/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { Flex, Typography } from 'antd';
import { useSelector } from 'react-redux';
import api from '../../utils/api';
import { getUserInfo } from '../../reducers/User/actions';
import RequestAccess from './RequestAccess';
import AccessRequestTable from './AccessRequestTable';

const { Title, Text } = Typography;

interface Organization {
  name: string;
  account_id: string;
}

const AccessManagement: React.FC = () => {
  const userInfo: any = useSelector(getUserInfo);
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [pendingOrgs, setPendingOrgs] = useState<string[]>([]);
  const [loadingOrgs, setLoadingOrgs] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const isAdmin = userInfo?.role === 'Admin';

  const availableOrganizations = organizations.filter((org) => !pendingOrgs.includes(org.name));

  const fetchOrganizations = async () => {
    setLoadingOrgs(true);
    try {
      const response = await api.get('/auth/organizations/all');
      setOrganizations(
        (response?.organizations || []).map((org: any) => ({
          name: org.name,
          account_id: org.account_id,
        })),
      );
    } catch {
      // Silently fail
    } finally {
      setLoadingOrgs(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const handleRequestSubmitted = () => {
    setRefreshKey((prev) => prev + 1);
    fetchOrganizations();
  };

  return (
    <Flex vertical gap={24} style={{ marginTop: 16 }}>
      <Flex vertical gap={8}>
        <Title level={2}>Access Management</Title>
        <Text>Manage user access requests for organizations</Text>
      </Flex>

      <RequestAccess
        organizations={availableOrganizations}
        loadingOrgs={loadingOrgs}
        onRequestSubmitted={handleRequestSubmitted}
      />

      <AccessRequestTable
        refreshKey={refreshKey}
        onActionComplete={fetchOrganizations}
        onPendingOrgsChange={setPendingOrgs}
      />
    </Flex>
  );
};

export default AccessManagement;
